import React, { useEffect, useState } from 'react';
import {
    ArrowImage,
    ArrowImageWrapper,
    BetslipContent,
    BetslipHeaderWrapper,
    CenterElements,
    HeaderItems,
    SideElements,
} from 'features/Betslip/styled';
import Text from 'ui/Text';
import { formatDenmarkCurrency, isTerminal } from 'utils/UiHelper';
import ArrowRightImg from './../../images/arrowRight.svg';

const BetslipHeader = ({
    openBetslipHandler = () => {},
    openPriceHandler = () => {},
    combinationCount,
    combinationPrice = 0.5,
    innerComponentMode = false,
    fullOpen = false,
    readOnly = false,
    className,
}) => {
    const [resultedPrice, setResultedPrice] = useState(1);

    useEffect(
        () => {
            setResultedPrice(combinationCount * combinationPrice);
        },
        [combinationCount, combinationPrice]
    );

    return (
        <BetslipContent className={isTerminal() ? 'terminal' : null}>
            <BetslipHeaderWrapper
                onClick={openBetslipHandler}
                readOnly={readOnly}
                className={className}
            >
                {!readOnly && !isTerminal() && <SideElements />}
                <CenterElements readOnly={readOnly}>
                    <HeaderItems>
                        <Text
                            capitalize
                            condensed
                            size={isTerminal() ? '16' : 'x07'}
                            color="#333333"
                            padding="0"
                        >
                            Antal rækker
                        </Text>
                        <Text
                            condensed
                            size={isTerminal() ? '20' : 'x15'}
                            color="#333333"
                            padding="0"
                            bold
                        >
                            {combinationCount}
                        </Text>
                    </HeaderItems>
                    {/*
                        Uncomment if feature with change bet price needs to get back
                        <HeaderItems active={!readOnly} onClick={openPriceHandler}>
                    */}
                    <HeaderItems active={false}>
                        <Text
                            capitalize
                            condensed
                            size={isTerminal() ? '16' : 'x07'}
                            color="#333333"
                            padding="0"
                        >
                            Rækkepris
                        </Text>
                        <Text
                            condensed
                            size={isTerminal() ? '20' : 'x15'}
                            color="#333333"
                            padding="0"
                            bold
                        >
                            {combinationPrice.toString().replace('.', ',')} kr.
                        </Text>
                    </HeaderItems>
                    <HeaderItems>
                        <Text
                            capitalize
                            condensed
                            size={isTerminal() ? '16' : 'x07'}
                            color="#333333"
                            padding="0"
                        >
                            Samlet pris
                        </Text>
                        <Text
                            condensed
                            size={isTerminal() ? '20' : 'x15'}
                            color="#333333"
                            padding="0"
                            bold
                        >
                            {formatDenmarkCurrency(resultedPrice)} kr.
                        </Text>
                    </HeaderItems>
                </CenterElements>
                {!readOnly &&
                    !isTerminal() && (
                        <SideElements>
                            {!innerComponentMode && (
                                <ArrowImageWrapper>
                                    <ArrowImage
                                        src={ArrowRightImg}
                                        alt={'arrowImage'}
                                        open={fullOpen}
                                        color={'white'}
                                    />
                                </ArrowImageWrapper>
                            )}
                        </SideElements>
                    )}
            </BetslipHeaderWrapper>
        </BetslipContent>
    );
};

export default BetslipHeader;
